import { observer } from 'mobx-react-lite'
import React from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import EliteAgencyTeamForm from './../EliteAgencyTeamForm/EliteAgencyTeamForm.component'
import Store from './../../store'

import './EliteAgencyTeamList.scss'

const EliteAgencyTeamList = props => {
  return (
    <MDBContainer fluid className='EliteAgencyTeamListComponent'>
      {Store.EliteAgencyTeams.map((EliteAgencyTeam, idx) => (
        <MDBRow key={`elite-agency-team-form-${EliteAgencyTeam?.id()}-${idx}`}>
          <MDBCol>
            <EliteAgencyTeamForm EliteAgencyTeam={EliteAgencyTeam} />
          </MDBCol>
        </MDBRow>
      ))}
    </MDBContainer>
  )
}

export default observer(EliteAgencyTeamList)
